<template>
    <div id="term_create" class="fleet-form-main">
        <div :class="`loader${loaderClass}`" v-show="loading">
        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <span class="page-title" id="termHeader" v-if="$route.params.id > 0">Update Term</span>
                    <span class="page-title" id="termHeader" v-else>Add Term</span>
                    <button type="submit" class="btn btn-secondary pull-right" v-on:click.prevent="BackTermList" >
                        <i class="fp-back"> </i> Back
                    </button>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content term-crud">
                        <section class="internal-container border-top-table-fl">
                            <form autocomplete="off" class="form-horizontal basic-form-container metric-form" id="TermForm">
                                <div class="form-row row-cols-md-4 row-cols-1">
                                    <div class="col form-group">
                                        <label class="control-label require" for="code">Code:</label>
                                        <input type="text" class="form-control" v-model="code" id="code" placeholder="Enter Code" name="code">
                                        <div class="field-error">{{code_error_msg}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="name">Name:</label>
                                        <input type="text" class="form-control" v-model="name" id="name" placeholder="Enter Name" name="name">
                                        <div class="field-error">{{name_error_msg}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="Term">Term:</label>
                                        <input type="number" min="0" class="form-control" v-model="term" id="term" placeholder="Enter Term" name="term" @keypress="isIntegerCheck($event)">
                                        <div class="field-error">{{term_error_msg}}</div>
                                    </div>  
                                    <div class="col form-group">
                                        <label class="control-label require" for="description">Period:</label>
                                        <v-select type="text" class="custom-ci-auto-search close-remove" v-model="period" label="text" :options="periodArr" id="period" placeholder="Select Period" name="period"></v-select>
                                        <div class="field-error">{{period_error_msg}}</div>
                                    </div>
                                </div>
                                <div class="form-row row-cols-md-2 row-cols-1">
                                    <div class="col form-group">
                                        <label class="control-label" for="description">Description:</label>
                                        <textarea rows="3" class="form-control" v-model="description" id="description" placeholder="Enter Description" name="description"></textarea>
                                        <div class="field-error"></div>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <div class="alert alert-warning hide offset-col-2 col-sm-6" id="alertError">
                                        <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                        <strong id="errorMsg" class="field-error"></strong>
                                    </div>
                                </div>
                                <div class="btn-groups">
                                    <button type="submit" id="CreateTermBtn" v-if="$route.params.id > 0" class="btn btn-primary" v-on:click.prevent="CreateTerm" >
                                    <i class="fp-reload"> </i>  Update
                                    </button>
                                    <button type="submit" id="CreateTermBtn" v-else class="btn btn-primary" v-on:click.prevent="CreateTerm" >
                                    <i class="fp-save"> </i>  Save
                                    </button>
                                    <button type="submit" id="createAndContinueTermBtn" v-if="$route.params.id == undefined" class="btn btn-tertiary" v-on:click.prevent="CreateTerm(flag='Save and Continue')" >
                                    <i class="fp-save-continue"> </i>  Save and Continue
                                    </button>
                                    <button type="submit" id="cancelTermBtn" class="btn btn-tertiary" v-on:click.prevent="BackTermList" >
                                    <i class="fp-close"> </i>  Cancel
                                    </button>
                                </div>
                            </form>
                        </section>        
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>
import Vue from "vue";

import {commonMixins} from '../mixins/commonMixins';


export default {
  name: "TermCreate",
  
  metaInfo() {
      return {title: (this.$route.params.id > 0)? "Update Term | " +process.env.COPYRIGHT_NAME : "Create Term | " +process.env.COPYRIGHT_NAME}
  },
  mixins:[commonMixins],
  data: () => ({
    permissions: [],
    cantAccessPage: "",
    name: "",
    code: "",
    description: "",
    loading:false,
    name_error_msg: "",
    code_error_msg: "",
    period:{text:'Days',value:'days'},
    term:'',
    periodArr:[{text:'Days',value:'days'},{text:'Month',value:'month'}],
    period_error_msg:'',
    term_error_msg:'',
  }),
  watch:{

        //check permission change
        permissions: function (permissions) {

            var self = this;
            if (permissions.length > 0) {
                for (var i = 0; i < permissions.length; i++) {
                    if (permissions[i].name == 'add_term') {
                        self.cantAccessPage = true;
                    }
                }
            }

        }
   },
  created: function() {

  },
  mounted: function() {
        var self = this;
        self.getPermissions();

        setTimeout(function () {
            var path = window.location.pathname;
            var segments = path.split("/");
            
            if (segments[3]) {
                self.loadTerm();
            }
        }, 100);
  },
  methods: {
    BackTermList() {
      var self = this;
      self.$router.push("/term/list");
    },

    CreateTerm(flag) {
      var self = this;

      self.code = self.code.trim();
      self.name = self.name.trim();

      self.name_error_msg = "";
      self.code_error_msg = "";
      self.term_error_msg = '',
      self.period_error_msg = '';

      if (!self.name || self.name == null || self.name == "") {
        self.name_error_msg = "Name Required.";
      }

      if (!self.term || self.term == '' || self.term == 0) {
        self.term_error_msg = "Term Required.";
      }

      if (!self.code || self.code == null || self.code == "") {
        self.code_error_msg = "Code Required.";
      }
      
      if (self.name_error_msg == "" && self.code_error_msg == "" && self.term_error_msg == "") {
            self.loading = true;
            var path = window.location.pathname;
            var segments = path.split("/");
            if (segments[3])
            {
                $("#CreateTermBtn").val("Updating ...");
                $("#CreateTermBtn").prop("disabled", true);
                $("#cancelTermBtn").prop("disabled",true);
            } else {
                if (flag == "Save and Continue") {

                    $("#createAndContinueTermBtn").val("Saving ...");
                    $("#CreateTermBtn").prop("disabled", true);
                    $("#createAndContinueTermBtn").prop("disabled", true);
                    $("#cancelTermBtn").prop("disabled",true);

                }else{

                    $("#CreateTermBtn").val("Saving ...");
                    $("#CreateTermBtn").prop("disabled", true);
                    $("#createAndContinueTermBtn").prop("disabled", true);
                    $("#cancelTermBtn").prop("disabled",true);
                }
               
            }
            
            $.ajax({
                url: process.env.ROOT_API + "/term/create",
                type: "POST",
                data: {name: self.name, id: segments[3], code: self.code, description: self.description,term:self.term,period:self.period.value},
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    if (segments[3])
                    {
                        $("#CreateTermBtn").val("Update");
                        $("#CreateTermBtn").prop("disabled", false);
                        $("#cancelTermBtn").prop("disabled",false);
                    } else {
                        if (flag == "Save and Continue") {

                            $("#createAndContinueTermBtn").val("Save and Continue");
                            $("#CreateTermBtn").prop("disabled", false);
                            $("#createAndContinueTermBtn").prop("disabled", false);
                            $("#cancelTermBtn").prop("disabled",false);

                        }else{

                            $("#CreateTermBtn").val("Save");
                            $("#CreateTermBtn").prop("disabled", false);
                            $("#createAndContinueTermBtn").prop("disabled", false);
                            $("#cancelTermBtn").prop("disabled",false);

                        }
                    }
                    if (data.status == "success") {

                        if (flag == "Save and Continue") {

                            $("#TermForm").trigger("reset");
                            self.name ="";
                            self.code = "";
                            self.description = "";
                    
                        }else{
                            self.$router.push("/term/list");
                        }

                    } else {
                        if (data.content.length > 0) {
                            var err = "";
                            for (var i = 0; i < data.content.length; i++) {
                                err += data.content[i] + "<br>";
                            }
                            $("#errorMsg").html(err);
                            $(".alert-warning").toggleClass("show");
                            setTimeout(function () {
                                $(".alert-warning").removeClass("show");
                                $(".alert-warning").addClass("hide");
                            }, 10000);
                        }
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    if (segments[3])
                    {
                        $("#CreateTermBtn").val("Update");
                        $("#CreateTermBtn").prop("disabled", false);
                        $("#cancelTermBtn").prop("disabled",false);
                    } else {
                        if (flag == "Save and Continue") {

                            $("#TermForm").trigger("reset");
                            

                            $("#createAndContinueTermBtn").val("Save and Continue");
                            $("#CreateTermBtn").prop("disabled", false);
                            $("#createAndContinueTermBtn").prop("disabled", false);
                            $("#cancelTermBtn").prop("disabled",false);

                        }else{

                            $("#CreateTermBtn").val("Save");
                            $("#CreateTermBtn").prop("disabled", false);
                            $("#createAndContinueTermBtn").prop("disabled", false);
                            $("#cancelTermBtn").prop("disabled",false);

                        }
                    }
                    self.generateStatusCodeMessage(jqXHR,true,'term-create')
                }
            });
      }else{
          self.errorValidationFocus();
      }
     
    },

    loadTerm() {
        var path = window.location.pathname;
        var segments = path.split("/");
        var self = this;
        self.loading = true;
        $.ajax({
            url: process.env.ROOT_API + "/term/" + segments[3],
            type: "GET",
            headers: this.ajxHeaders,
            dataType: "json",
            success: function (data) {
                self.loading = false;
                console.log(data);
                if (data.status == "success") {
                    self.name = data.content.name;
                    self.code = data.content.code;
                    self.description = data.content.description;
                    self.period = {text:self.titleCase(data.content.period),value:data.content.period};
                    self.term = data.content.term;
                } 
            },
            error: function (jqXHR, exception) {
                self.loading = false;
                self.generateStatusCodeMessage(jqXHR,false,'term-load-by-id')
            }
        });
    },
    titleCase(str) {
            if (str == null) {
                return;
            } else {
                var value = str.toString()
                return value.charAt(0).toUpperCase() + value.slice(1)
            }
        },
  }
};
</script>


// WEBPACK FOOTER //
// src/components/TermCreate.vue